const getCVEURL = (cve) => {
  return `https://www.cve.org/CVERecord?id=${cve}`;
};
const getCWEURL = (cwe) => {
  const id = cwe?.replace('CWE-', '');
  return `https://cwe.mitre.org/data/definitions/${id}.html`;
};

export { getCVEURL, getCWEURL };
